import React from 'react';

import { Button, ButtonGroup, StandardButton } from '@eika/button';

import useTranslation from '../../../../../hooks/useTranslation';
import { EikaModal } from '../../../../EikaModal';
import FilterDateRangeInput from '../../FilterDateRangeInput/FilterDateRangeInput';
import { useTransactionFilterContext } from '../../TransactionFilterContext/TransactionFilterContext';
import { isOneYearFromToday } from '../../utils/getSearchDates';

type Props = {
    open: boolean;
    onClose: () => void;
};

const MobileDateRangeModal: React.FC<Props> = ({ open, onClose }) => {
    const translated = useTranslation();

    const { dateRange } = useTransactionFilterContext();
    return (
        <EikaModal contentShouldStretch id="daterange-submodal" open={open} setOpen={() => null} onClose={onClose}>
            <section className="modal-content">
                <FilterDateRangeInput />
                <ButtonGroup
                    className="transaction-filter-form__sub-submit-wrapper"
                    primaryAction={
                        <Button className="margin-top-auto-button" type="button" onClick={onClose}>
                            {translated.transactionFilter.choose}
                        </Button>
                    }
                    hideSecondaryAction={isOneYearFromToday(dateRange.fromDate.value)}
                    secondaryAction={
                        <StandardButton buttonType="negative" onClick={dateRange.reset}>
                            {translated.transactionFilter.removeChosen}
                        </StandardButton>
                    }
                />
            </section>
        </EikaModal>
    );
};

export default MobileDateRangeModal;
